var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 57.5C14.8122 57.5 2.5 45.1878 2.5 30C2.5 14.8122 14.8122 2.5 30 2.5C45.1878 2.5 57.5 14.8122 57.5 30C57.5 45.1878 45.1878 57.5 30 57.5ZM48.4987 42.8116C51.0215 39.1758 52.5 34.7606 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 34.7606 8.97846 39.1758 11.5013 42.8116C14.3149 39.0952 20.9265 37.5 30 37.5C39.0735 37.5 45.6851 39.0952 48.4987 42.8116ZM44.9117 46.8494C44.18 44.2184 38.9235 42.5 30 42.5C21.0765 42.5 15.82 44.2184 15.0883 46.8494C19.0583 50.3654 24.2798 52.5 30 52.5C35.7201 52.5 40.9417 50.3654 44.9117 46.8494ZM30 15C23.9477 15 20 19.3894 20 25C20 33.5684 24.4022 37.5 30 37.5C35.5452 37.5 40 33.699 40 25.5C40 19.8039 36.0355 15 30 15ZM25 25C25 30.6731 27.0455 32.5 30 32.5C32.9443 32.5 35 30.746 35 25.5C35 22.376 33.0391 20 30 20C26.8343 20 25 22.0396 25 25Z",
    fill: "#D1ADFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 57.5C14.8122 57.5 2.5 45.1878 2.5 30C2.5 14.8122 14.8122 2.5 30 2.5C45.1878 2.5 57.5 14.8122 57.5 30C57.5 45.1878 45.1878 57.5 30 57.5ZM48.4987 42.8116C51.0215 39.1758 52.5 34.7606 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 34.7606 8.97846 39.1758 11.5013 42.8116C14.3149 39.0952 20.9265 37.5 30 37.5C39.0735 37.5 45.6851 39.0952 48.4987 42.8116ZM44.9117 46.8494C44.18 44.2184 38.9235 42.5 30 42.5C21.0765 42.5 15.82 44.2184 15.0883 46.8494C19.0583 50.3654 24.2798 52.5 30 52.5C35.7201 52.5 40.9417 50.3654 44.9117 46.8494ZM30 15C23.9477 15 20 19.3894 20 25C20 33.5684 24.4022 37.5 30 37.5C35.5452 37.5 40 33.699 40 25.5C40 19.8039 36.0355 15 30 15ZM25 25C25 30.6731 27.0455 32.5 30 32.5C32.9443 32.5 35 30.746 35 25.5C35 22.376 33.0391 20 30 20C26.8343 20 25 22.0396 25 25Z",
    fill: "url(#paint0_linear_3_20)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_20",
    x1: 2.59658,
    y1: 57.5,
    x2: 61.315,
    y2: 52.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E71E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#8017F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BC0E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGradient);
export default __webpack_public_path__ + "static/media/user-gradient.f89900fa.svg";
export { ForwardRef as ReactComponent };